import { DepositStatusEnum } from 'src/graphql/schema';

export const depositStatusOptions = [
  {
    label: 'Awaiting',
    value: DepositStatusEnum.Awaiting,
  },
  {
    label: 'No configuration',
    value: DepositStatusEnum.NoConfiguration,
  },
  {
    label: 'Taken',
    value: DepositStatusEnum.Taken,
  },
  {
    label: 'Error',
    value: DepositStatusEnum.Error,
  },
];

export const depositStatusMap = {
  [DepositStatusEnum.Awaiting]: {
    label: 'Awaiting',
    variant: 'outline',
  },
  [DepositStatusEnum.NoConfiguration]: {
    label: 'Not configured',
    variant: 'secondary',
  },
  [DepositStatusEnum.Taken]: {
    label: 'Taken',
    variant: 'default',
  },
  [DepositStatusEnum.Error]: {
    label: 'Error',
    variant: 'destructive',
  },
} as const;
